import {Action} from 'common/widgets/query-entry-section/types';

import {SuperEntryRow} from '../super-entry';
import {FlowsEntryRowEl} from './template';

/**
 * FlowsEntryRow implements flows report specific features in the query builder.
 *
 */
export class FlowsEntryRow extends SuperEntryRow {
  template = FlowsEntryRowEl;

  handleReverseStepsUpdate(reverse: number): void {
    const delta = Math.abs(this.entry.reverse - reverse);
    const entry = {
      ...this.entry,
      reverse,
    };

    this.section.updateEntries(Action.EditFlowSteps, {entry, index: this.index, trackingProps: {reverse, delta}});
  }

  handleForwardStepsUpdate(forward: number): void {
    const delta = Math.abs(this.entry.forward - forward);
    const entry = {
      ...this.entry,
      forward,
    };

    this.section.updateEntries(Action.EditFlowSteps, {entry, index: this.index, trackingProps: {forward, delta}});
  }
}
